import { Component } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { Supplier } from "src/app/inventory/supplier/supplier";
import { SupplierService } from "src/app/inventory/supplier/supplier.service";
import { Page } from "src/app/util/page";
import { Criteria } from "src/app/util/search/criteria/criteria";
import { SearchComponent } from "src/app/util/search/search-component";
import { SearchRequest } from "src/app/util/search/search-request";

@Component({
  styleUrls: ['./new-purchase-order.component.css'],
  templateUrl: './new-purchase-order.component.html',
})
export class NewPurchaseOrderComponent extends SearchComponent<Supplier> {
  public applyButtonTitle!: string;
  public onConfirm!: (supplier: Supplier) => void;


  constructor(
    private modalService: NgbModal,
    private supplierService: SupplierService,
  ) {
    super(new Map<string, Criteria>());

    this.refresh();
  }

  public refresh(): void {
    this.search();
  }

  public newReception(supplier: Supplier) {
    this.modalService.dismissAll();

    this.onConfirm(supplier);
  }

  public onSearch(searchRequest: SearchRequest, page: number): Observable<Page<Supplier>> {
    return this.supplierService.findAll({
      name: searchRequest.query,
    }, page, 50);
  }
}